"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Head = void 0;

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../../atoms");

var _Table = require("../Table.style");

var _images = require("../../../assets/images");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Head = ({
  columns,
  isSelectable,
  showIndex,
  enableSort,
  selectAll,
  collapse,
  sort,
  handleSelectAll,
  handleSort,
  isPartialCheck
}) => {
  return /*#__PURE__*/_react.default.createElement(_Table.StyledHead, null, /*#__PURE__*/_react.default.createElement(_Table.StyledRow, {
    className: "table-main-row"
  }, showIndex && /*#__PURE__*/_react.default.createElement(_Table.StyledTh, {
    isSelectable: isSelectable,
    showIndex: showIndex,
    isSortable: true
  }, isSelectable ? /*#__PURE__*/_react.default.createElement(_Table.CheckboxWrapper, null, /*#__PURE__*/_react.default.createElement(_atoms.Checkbox, {
    name: (0, _uuid.v4)(),
    onChange: e => handleSelectAll(e),
    checked: selectAll,
    isPartial: isPartialCheck,
    value: '',
    "data-testid": "select-all"
  })) : '#'), collapse.length !== 0 && /*#__PURE__*/_react.default.createElement(_Table.StyledTh, {
    className: "expansion-cell"
  }), columns.length > 0 && columns.map(({
    title,
    accessor,
    isSortable = true,
    className
  }, i) => /*#__PURE__*/_react.default.createElement(_Table.StyledTh, {
    key: i,
    sort: '' + sort[i].status,
    isCollapse: collapse.length !== 0,
    isSortable: isSortable,
    className: className || '',
    onClick: () => handleSort(accessor, i)
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", null, title), title !== '\u00a0' && enableSort && isSortable && /*#__PURE__*/_react.default.createElement(_Table.StyledSortArrow, {
    sort: '' + sort[i].status
  }, /*#__PURE__*/_react.default.createElement(_images.DownArrow, null)))))));
};

exports.Head = Head;
Head.propTypes = {
  columns: _propTypes.default.array,
  isSelectable: _propTypes.default.bool,
  showIndex: _propTypes.default.bool,
  enableSort: _propTypes.default.bool,
  selectAll: _propTypes.default.bool,
  collapse: _propTypes.default.array,
  sort: _propTypes.default.array,
  handleSelectAll: _propTypes.default.func,
  handleSort: _propTypes.default.func,
  isPartialCheck: _propTypes.default.bool
};